module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-calendar-header"
  }, [_c('div', {
    staticClass: "header-left"
  }, [_vm._t("header-left")], 2), _vm._v(" "), _c('div', {
    staticClass: "header-center"
  }, [_c('span', {
    staticClass: "prev-month",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$_onPrevClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.leftArrow))]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('span', {
    staticClass: "next-month",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$_onNextClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.rightArrow))])]), _vm._v(" "), _c('div', {
    staticClass: "header-right"
  }, [_vm._t("header-right")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2381de79"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/header.vue
// module id = 353
// module chunks = 0